// import the api endpoints
import router from "../../router";
import {
  apiHealthcheck,
  apiDbInfo,
  apiLogin,
  apiLogout,
} from "@/api/session.api";
import * as utils from "../../utils/utils";
import { apiGetTenantClients, apiRefreshToken } from "../../api/session.api";
import { handleRouterPushError } from "../../utils/component-utils";
import modules from "../modules";
//import { Vue } from "vue"

// State object
const initialState = () => ({
  accentColor: "23, 162, 184",
  auth: {},
  breadcrumbTrail: ["one", "two"],
  creatingNewItem: false,
  dashboardPath: "/",
  freezeIsLoading: false,
  fromItemDetail: false,
  isLoading: false,
  isNavigatingBack: false,
  isRefreshing: false,
  permissions: [],
  routeHistory: [],
  scope: "",
  showLoading: true,
  sidebarHidden: JSON.parse(localStorage.getItem("sidebarHidden")) || false,
  subNav: "",
  tenantClients: [],
  user: {},
});
const state = initialState();

// Getter functions
const getters = {
  user: (state) => {
    return state.user;
  },
  accentColor: (state) => state.accentColor,
  auth: (state) => state.auth,
  authExpiryMinutes: (state) => state?.auth?.accessTokenExpiryMinutes,
  authExpiry: (state) => state.auth.expiry,
  authToken: (state) => state.auth.accessToken,
  breadcrumbTrail: (state) => state.breadcrumbTrail,
  creatingNewItem: (state) => state.creatingNewItem,
  customDashboard: (state) => state.user.customDashboard,
  dashboardPath: (state) => state.dashboardPath,
  fromItemDetail: (state) => state.fromItemDetail,
  isAdmin: (state) => state.user.isAdmin,
  isAuthenticated: (state) => !utils.isObjectEmpty(state.user),
  //isAuthorized: (state) => (resource, action) => {
  isAuthorized: () => () => {
    return true;
    // TODO: Reinstate permissions
    // if (resource === "Session") return true;
    // let resourcePerm = null;
    // for (let i = 0; i < Object.keys(state.permissions).length; i++) {
    //   if (state.permissions[i].resource === resource) {
    //     resourcePerm = state.permissions[i];
    //     break;
    //   }
    // }
    // //const resourcePerm = state.permissions.find(x=>x.resource === resource)
    // if (resourcePerm === null) {
    //   // No permission for this resource
    //   return false;
    // }
    // // Resource permitted; check rights
    // return resourcePerm[action];
  },
  isLoading: (state) => state.isLoading && state.showLoading,
  isNavigatingBack: (state) => state.isNavigatingBack,
  isRefreshing: (state) => state.isRefreshing,
  role: (state) => state.user.role,
  routeHistory: (state) => state.routeHistory,
  lastRoute: (state) =>
    state.routeHistory.length
      ? state.routeHistory[state.routeHistory.length - 1]
      : null,
  scope: (state) => state.scope,
  showLoading: (state) => state.showLoading,
  sidebarHidden: (state) => state.sidebarHidden,
  subNav: (state) => state.subNav,
  tenantClients: (state) => state.tenantClients,
  tenantSelectedClient: (state) => state.user.tenantSelectedClient,
};

// Actions
const actions = {
  async fetchHealthcheck() {
    const response = await apiHealthcheck();
    return response;
  },
  async fetchDbInfo() {
    const response = await apiDbInfo();
    return response;
  },

  async fetchTenantClients({ state, commit }) {
    const response = await apiGetTenantClients(state.user.tenantId);
    commit("SET_TENANT_CLIENTS", response.data);
    const defaultSelectedClient = {
      clientName: "All clients",
      clientId: "0",
      colorBadge: "",
    };
    commit("SET_TENANT_SELECTED_CLIENT", defaultSelectedClient);
  },

  async login({ commit, dispatch, state }, { userId, password }) {
    const response = await apiLogin(userId, password);
    commit("SET_AUTH", { ...response?.data?.auth });
    const authExpiry = utils.addMinutes(state?.auth?.accessTokenExpiryMinutes);
    commit("SET_AUTH_EXPIRY", authExpiry);
    commit("SET_USER", { ...response?.data?.user });
    commit("SET_PERMISSIONS", { ...response?.data?.permissions });
    commit("SET_SCOPE", response?.data?.user.scope);
    // Get tenant clients if this is tenant scope
    if (state.scope === "tenant") {
      await dispatch("fetchTenantClients");
    }

    // Initialize each store after login to accurately determine user scope (tenant or client)
    const moduleNames = Object.keys(modules);
    for (const moduleName of moduleNames) {
      if (modules[moduleName].actions?.initializeStore) {
        await dispatch(`${moduleName}/initializeStore`, null, { root: true });
      }
    }
  },
  async initializeStore() {},
  // Refresh access token
  async refreshToken({ state, commit }) {
    const response = await apiRefreshToken(state.user);
    commit("SET_AUTH", { ...response?.data?.auth });
    const authExpiry = utils.addMinutes(state?.auth?.accessTokenExpiryMinutes);
    commit("SET_AUTH_EXPIRY", authExpiry);
  },

  async logout({ dispatch }, doApiLogout) {
    await router.push({ path: "/login" }).catch((err) => {
      handleRouterPushError(err);
    });
    if (doApiLogout) {
      await apiLogout();
    }
    dispatch("reset", {}, { root: true });
  },

  sidebarHidden({ commit }, payload) {
    commit("SET_SIDEBAR_HIDDEN", payload);
  },

  toDashboard({ commit, getters }) {
    // Route to dashboard component based on resource permissions
    if (getters.isAuthorized("DashboardSlcPrep", "read")) {
      //TODO: Once we turn IsAuthorized back on, set up permissions for dashboards.
      commit("SET_DASHBOARD_PATH", "/");
      //      commit("SET_DASHBOARD_PATH", "/DashboardSlcPrep");
    } else {
      commit("SET_DASHBOARD_PATH", "/");
    }
  },
  reset({ commit }) {
    commit("RESET");
  },

  // Accent color is defined in compont-utils.js
  setAccentColor({ commit }, payload) {
    commit("SET_ACCENT_COLOR", payload);
  },
  // setDashboardPath({ commit }, payload) {
  //   commit("SET_DASHBOARD_PATH", payload);
  // },
  setIsLoading({ commit }, payload) {
    commit("SET_LOADING", payload);
  },
  freezeIsLoading({ commit }, payload) {
    commit("SET_FREEZE_IS_LOADING", payload);
  },
  setIsRefreshing({ commit }, payload) {
    commit("SET_REFRESHING", payload);
  },
  setPermissions({ commit }, payload) {
    commit("SET_PERMISSIONS", payload);
  },
  setShowLoading({ commit }, payload) {
    commit("SET_SHOW_LOADING", payload);
  },
  setSubNav({ commit }, payload) {
    commit("SET_SUBNAV", payload);
  },
};

// Mutations
const mutations = {
  ADD_BREADCRUMB(state, breadcrumbItem) {
    state.breadcrumbTrail.push(breadcrumbItem);
  },
  REMOVE_LAST_BREADCRUMB(state, lastIndex) {
    state.breadcrumbTrail.splice(lastIndex, 1);
  },
  RESET_BREADCRUMB(state, breadcrumbTrail) {
    if (!breadcrumbTrail[0].name) return;
    state.breadcrumbTrail = breadcrumbTrail;
  },
  PUSH_ROUTE_HISTORY(state, route) {
    state.routeHistory.push(route);
  },
  CLEAR_ROUTE_HISTORY(state) {
    state.routeHistory = [];
  },
  POP_ROUTE_HISTORY(state) {
    return state.routeHistory.pop();
  },
  SET_NAVIGATION_BACK_FLAG(state, value) {
    state.isNavigatingBack = value;
  },

  RESET(state) {
    Object.assign(state, initialState());
  },
  SET_ACCENT_COLOR(state, data) {
    state.accentColor = data;
  },
  SET_AUTH(state, data) {
    state.auth = data;
  },
  SET_AUTH_EXPIRY(state, data) {
    state.auth.expiry = new Date(data).toISOString();
  },
  SET_CREATING_NEW_ITEM(state, value) {
    state.creatingNewItem = value;
  },
  SET_DASHBOARD_PATH(state, data) {
    state.dashboardPath = data;
  },
  SET_FROM_ITEM_DETAIL(state, value) {
    state.fromItemDetail = value;
  },
  SET_LOADING(state, data) {
    // Don't turn off is loading if overridden
    if (data === false && state.freezeIsLoading) {
      return;
    }
    state.isLoading = data;
  },
  SET_FREEZE_IS_LOADING(state, data) {
    state.freezeIsLoading = data;
    if (data === false) {
      state.isLoading = false;
    }
  },
  SET_PERMISSIONS(state, data) {
    state.permissions = data;
  },
  SET_REFRESHING(state, data) {
    state.isRefreshing = data;
  },
  SET_SCOPE(state, data) {
    state.scope = data;
  },
  SET_SHOW_LOADING(state, data) {
    state.showLoading = data;
  },
  SET_SIDEBAR_HIDDEN(state, sidebarHidden) {
    state.sidebarHidden = sidebarHidden;
    localStorage.setItem("sidebarHidden", JSON.stringify(sidebarHidden));
  },
  SET_SUBNAV(state, data) {
    state.subNav = data;
  },
  SET_TENANT_SELECTED_CLIENT(state, data) {
    // state.tenantSelectedClient = data;
    state.user.tenantSelectedClient = data;
  },
  SET_TENANT_CLIENTS(state, data) {
    state.tenantClients = data;
  },
  SET_USER(state, data) {
    if (!Object.prototype.hasOwnProperty.call(data, "tenantSelectedClient"));
    {
      data.tenantSelectedClient = {};
    }
    state.user = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
